import { render, staticRenderFns } from "./CheckAuthorization.vue?vue&type=template&id=2dd8af91&scoped=true&"
import script from "./CheckAuthorization.vue?vue&type=script&lang=js&"
export * from "./CheckAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd8af91",
  null
  
)

/* custom blocks */
import block0 from "./CheckAuthorization.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports